import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class SubscribePublishService {
  // 分页查询订阅发布列表
  static async geDataList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/SubscribePublish?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增订阅发布
  static async addSubscribeApply(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/SubscribePublish', payload))
    return Callback(err, res)
  }
  // 查看订阅发布详情
  static async readSubscribeApply(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/SubscribePublish/${payload}`))
    return Callback(err, res)
  }
  // 删除订阅发布
  static async delSubscribeApply(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/SubscribePublish/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 编辑订阅发布
  static async updateSubscribeApply(id, payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/SubscribePublish/${id}`, payload))
    return Callback(err, res)
  }
  // 分页查询已订阅发布的实体
  static async subscribeClassPagedResult(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/SubscribePublish/subscribe-class-paged-result?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 批量启用
  static async enable(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/SubscribePublish/enable', payload)
    )
    return Callback(err, res)
  }
  // 批量禁用
  static async disable(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/SubscribePublish/disable', payload)
    )
    return Callback(err, res)
  }
}
